import {
   shortDate,
   mediumDate,
   longDate,
   dateTime,
   parseDate,
   parseUtc,
   monthAndYear,
} from './date'
import { titleCase, list, unique, sort, pluck, plural } from './string'
import { filesize } from './number'

export default {
   install(vueInstance: any) {
      vueInstance.filter('titleCase', titleCase)
      vueInstance.filter('shortDate', shortDate)
      vueInstance.filter('mediumDate', mediumDate)
      vueInstance.filter('longDate', longDate)
      vueInstance.filter('dateTime', dateTime)
      vueInstance.filter('monthAndYear', monthAndYear)
      vueInstance.filter('parseDate', parseDate)
      vueInstance.filter('parseUtc', parseUtc)
      vueInstance.filter('list', list)
      vueInstance.filter('unique', unique)
      vueInstance.filter('sort', sort)
      vueInstance.filter('pluck', pluck)
      vueInstance.filter('filesize', filesize)
      vueInstance.filter('plural', plural)
   },
}
